import React, {Component} from 'react';
import {Input, Form, Button, FormGroup, FormFeedback} from 'reactstrap';
import { connect } from 'react-redux';
import Preloader from '../../components/UI/Preloader';
import { Preloading } from './../UI/Preloader/action';
import { toast, ToastContainer} from 'react-toastify';
import { changePassword, changePasswordResponse, validateJwtToken, validateJwtTokenSuccess } from './action';
import Logo from '../logo';
import { jwtDecode } from "jwt-decode";

class ChangePassword extends Component{

    state = { old_password :"", new_password:"", confirm_password :"", disabled : true, error : {}, passwordErrors: [], validateTokenStatus:"" };

    componentDidMount(){
        const {token}  = this.props.match.params;
        if(token){
            const requestData = {"jwtToken": token};
            this.props.validateJwtToken(requestData);
        }
    }

    isTokenExpired = (token) => {
        try {
            const decoded = jwtDecode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    componentWillUnmount() {
        this.props.preloading(false);
    }

    componentDidUpdate(prevProps) {
        
      if ( this.props.change_password && this.props.change_password.status && this.props.change_password.status !== prevProps.change_password.status  && this.props.change_password.status === 200) {
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp; Your password is changed !
                </div>
            );
            this.props.preloading(false);

            setTimeout(function(){
                // Redirect to login screen
                window.location = '/';
            }, 500);
        } else if ( this.props.change_password && this.props.change_password.status && this.props.change_password.status !== prevProps.change_password.status && this.props.change_password.status !== 422) {
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;{this.props.change_password.message}
                </div>
            );
            this.props.preloading(false);
        } else if (this.props.change_password && this.props.change_password.status && this.props.change_password !== prevProps.change_password && this.props.change_password.status == 422) {
            let error = this.props.change_password.message;
            let errorsList = error.split(",");
            this.setState( {passwordErrors : errorsList} )
            this.props.preloading(false);
        } else if (this.props.validating_jwt_token && this.props.validating_jwt_token.status && this.props.validating_jwt_token.status !== prevProps.validating_jwt_token.status) {
            this.setState({
                validateTokenStatus : this.props.validating_jwt_token.status
            });
            this.validateTokenExpired(this.props.validating_jwt_token.status);
        }else if(this.props.validating_jwt_token_failure && this.props.validating_jwt_token_failure.status && this.props.validating_jwt_token_failure.status !== prevProps.validating_jwt_token_failure.status){
            this.setState({
                validateTokenStatus : this.props.validating_jwt_token_failure.status
            });
            this.validateTokenExpired(this.props.validating_jwt_token_failure.status);
        }
    }

    validateTokenExpired=(status)=>{
        const {token}  = this.props.match.params;
        const isExpired = this.state.validateTokenStatus == 200 || (status && status == 200) ? false : true;
        if(isExpired){
            this.props.changePasswordResponse({ message : "Link is expired, please try again !", status : 401});
            setTimeout(function(){
                // Redirect to forgot password page
                window.location = '/forgot';
            }, 3000);
        }
        this.setState({token : token})
    }
        
    changePassword = (e) => {
        e.preventDefault();
        if(this.state.confirm_password === this.state.new_password ){
            let payload = { password: this.state.new_password, 
                            token : this.state.token };
            this.props.preloading(true);
            this.props.changePassword(payload);
            }
    }

    validateForm = (name, value) =>{
        let error = undefined;
        let disabled = true;
    
        if(value.length < 3 ){
           error = "Minimum length should be 3 charcters ";
        }
        if(!error){
            if(((name === "new_password" && this.state.confirm_password !== value )
             || (name === "confirm_password" && this.state.new_password !== value )) ) {
                error = "Confirm password and New password should be same !";
             } else  if(((name === "new_password" && this.state.confirm_password === value )
             || (name === "confirm_password" && this.state.new_password === value )) ) {
                error = undefined;
                disabled = false;
             }
        }
        this.setState( {[name] : value, disabled :disabled, error :{[name] : error}, passwordErrors: []} )
    }

    handleFormInput = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.validateForm(name, value)
        
    }

    render(){
        return (
            <section className=" d-flex align-items-center justify-content-center h-100vh" /* style={{ "marginLeft" : "20%" }} */>
                <section className="pre-login" /* style={{ padding :"40px 25px"}} */>
                        <Form>
                            <Logo propClassName="mb-5" />
                           
                            <FormGroup className="mb-4">
                                <Input type="password" value ={this.state.new_password }  name="new_password" id="new_password" placeholder="New Password" required invalid={this.state.error["new_password"] } onChange ={ (e)=>this.handleFormInput(e)} />
                                <FormFeedback className="text-left" style={{ display : "block"}} invalid>{this.state.error["new_password"] }</FormFeedback>
                                {
                                    this.state.passwordErrors.map((error, index) => (
                                        <FormFeedback key={index}  className="text-left" style={{ display : "block"}} invalid>{error}</FormFeedback>
                                ))}
                            </FormGroup>
                            <FormGroup className="mb-4">
                                <Input type="password"  value ={this.state.confirm_password }  name="confirm_password" id="confirm_password" placeholder="Confirm new Password" required invalid={this.state.error["confirm_password"] } onChange ={ (e)=>this.handleFormInput(e)} />
                                <FormFeedback className="text-left" style={{ display : "block"}} invalid>{this.state.error["confirm_password"] }</FormFeedback>
                            </FormGroup>
                            <Button size="lg"className="mb-4" name="btn-forgotPassword" color="primary" block disabled={this.state.disabled} onClick={(e)=>this.changePassword(e)}>Change password</Button>
                        </Form>
                </section>

                <Preloader></Preloader>
                <ToastContainer hideProgressBar={true} position="top-center" autoClose={3000}></ToastContainer>
            </section>
        )
    }
}

const mapStateToProps = (state) =>({ 
    change_password : state.changePassword.change_password,
    validating_jwt_token : state.changePassword.validating_jwt_token,
    validating_jwt_token_failure: state.changePassword.validating_jwt_token_failure
 });

const mapDispatchToProps = dispatch => ({
    changePassword: (changePasswordRequest) => { dispatch(changePassword(changePasswordRequest)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    changePasswordResponse : (payload) =>{dispatch(changePasswordResponse(payload))},
    validateJwtToken : (data) =>{dispatch(validateJwtToken(data))},
    validateJwtTokenSuccess : (data) =>{dispatch(validateJwtTokenSuccess(data))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChangePassword);